
/*
 * MAKELOVE — AJAX CART
 * Works with the existing Shopify cart drawer
 * and ajax-cart-template.liquid.
 */

(function (window, $) {
  'use strict';

  if (!$) return;

  var ShopifyAPI = window.ShopifyAPI =
    window.ShopifyAPI || {};

  var shopify = window.Shopify =
    window.Shopify || {};

  var settings = {};
  var busy = false;
  var initialized = false;
  var $cartContainer = $();
  var $body = $('body');

  function money(cents) {
    if (typeof shopify.formatMoney === 'function') {
      return shopify.formatMoney(
        cents,
        settings.moneyFormat
      );
    }
    return '$' + (
      Number(cents || 0) / 100
    ).toFixed(2);
  }

  function safeError(xhr) {
    var data = xhr && xhr.responseJSON;

    if (!data && xhr && xhr.responseText) {
      try {
        data = JSON.parse(xhr.responseText);
      } catch (e) {}
    }

    return (
      data && (data.description || data.message)
    ) || 'Could not update your bag. Please try again.';
  }

  function request(method, url, data) {
    return $.ajax({
      type: method,
      url: url,
      data: data,
      dataType: 'json'
    });
  }

  ShopifyAPI.onCartUpdate =
    ShopifyAPI.onCartUpdate || function () {};

  ShopifyAPI.onError = function (xhr) {
    window.alert(safeError(xhr));
  };

  ShopifyAPI.getCart = function (callback) {
    return request('GET', '/cart.js')
      .done(function (cart) {
        if (typeof callback === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
      });
  };

  ShopifyAPI.addItemFromForm = function (
    form,
    callback,
    errorCallback
  ) {
    return request(
      'POST',
      '/cart/add.js',
      $(form).serialize()
    )
    .done(function (item) {
      if (typeof callback === 'function') {
        callback(item, form);
      } else if (
        typeof ShopifyAPI.onItemAdded === 'function'
      ) {
        ShopifyAPI.onItemAdded(item, form);
      }
    })
    .fail(function (xhr) {
      if (typeof errorCallback === 'function') {
        errorCallback(xhr);
      } else {
        ShopifyAPI.onError(xhr);
      }
    });
  };

  ShopifyAPI.changeItem = function (
    line,
    quantity,
    callback
  ) {
    return request('POST', '/cart/change.js', {
      line: line,
      quantity: quantity
    })
    .done(function (cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    })
    .fail(ShopifyAPI.onError);
  };

  ShopifyAPI.updateCartNote = function (
    note,
    callback
  ) {
    return request('POST', '/cart/update.js', {
      note: note
    })
    .done(function (cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    })
    .fail(ShopifyAPI.onError);
  };

  function updateHeader(cart) {
    if (settings.cartCountSelector) {
      $(settings.cartCountSelector)
        .text(cart.item_count)
        .toggleClass(
          'hidden-count',
          cart.item_count === 0
        );
    }

    if (settings.cartCostSelector) {
      $(settings.cartCostSelector).html(
        money(cart.total_price)
      );
    }

    $('.js-number-cart').toggleClass(
      'active',
      cart.item_count > 0
    );

    $('.product-popup .product-item-count')
      .text(cart.item_count);
  }

  function emptyHtml() {
    return (
      '<div class="ml-cart-empty">' +
        '<div class="ml-cart-empty-icon" ' +
          'aria-hidden="true">&#9633;</div>' +
        '<h3>Your bag is empty</h3>' +
        '<p>Find something worth keeping.</p>' +
        '<a href="/collections/all" ' +
          'class="ml-cart-checkout">' +
          'EXPLORE COLLECTION &rarr;' +
        '</a>' +
      '</div>'
    );
  }

  function renderCart(cart) {
    updateHeader(cart);

    if (!$cartContainer.length) return;

    if (!cart.item_count) {
      $cartContainer.html(emptyHtml());
    } else {
      var rawTemplate = $('#CartTemplate').html();

      if (!rawTemplate || !window.Handlebars) {
        console.error(
          'MAKELOVE: Missing cart template or Handlebars.'
        );
        return;
      }

      var items = $.map(
        cart.items,
        function (item, index) {
          return {
            id: item.variant_id,
            line: index + 1,
            url: item.url,
            img: item.image || '',
            name: item.product_title,
            variation:
              item.variant_title === 'Default Title'
                ? ''
                : item.variant_title,
            properties: item.properties,
            itemQty: item.quantity,
            itemAdd: item.quantity + 1,
            itemMinus: item.quantity - 1,
            price: money(
              item.final_line_price != null
                ? item.final_line_price
                : item.line_price
            ),
            vendor: item.vendor
          };
        }
      );

      var template = window.Handlebars.compile(
        rawTemplate
      );

      $cartContainer.html(
        template({
          items: items,
          note: cart.note,
          totalPrice: money(cart.total_price)
        })
      );
    }

    $body.removeClass('drawer--is-loading');

    $body.trigger(
      'ajaxCart.afterCartLoad',
      [cart]
    );
  }

  function refresh(openAfter) {
    $body.addClass('drawer--is-loading');

    return ShopifyAPI.getCart(function (cart) {
      renderCart(cart);

      // Open only after the updated cart is rendered.
      if (
        openAfter &&
        typeof window.MLopenCart === 'function'
      ) {
        window.MLopenCart();
      }
    })
    .fail(function (xhr) {
      $body.removeClass('drawer--is-loading');
      ShopifyAPI.onError(xhr);
    });
  }

  function submitAddToCart(event) {
    var form = event.currentTarget;
    var $form = $(form);

    var $button = $form
      .find(settings.addToCartSelector)
      .first();

    if (!$button.length) return;

    event.preventDefault();

    if (busy || $button.is(':disabled')) {
      return;
    }

    busy = true;

    $button
      .addClass('is-adding')
      .removeClass('is-added');

    $form.find('.qty-error').remove();

    ShopifyAPI.addItemFromForm(
      form,

      function () {
        $button
          .removeClass('is-adding')
          .addClass('is-added');

        refresh(true).always(function () {
          busy = false;
        });
      },

      function (xhr) {
        busy = false;

        $button.removeClass(
          'is-adding is-added'
        );

        $('<div class="errors qty-error" role="alert"></div>')
          .text(safeError(xhr))
          .appendTo($form);
      }
    );
  }

  function updateQuantity(line, quantity) {
    if (busy || !line) return;

    busy = true;

    var $row = $cartContainer.find(
      '.ajaxcart__row[data-line="' + line + '"]'
    );

    $row.addClass('is-loading');

    ShopifyAPI.changeItem(
      line,
      quantity,
      function (cart) {
        busy = false;
        renderCart(cart);
      }
    )
    .fail(function () {
      busy = false;
      $row.removeClass('is-loading');
    });
  }

  function bindCartControls() {
    $body.on(
      'click.makeloveAjax',
      '.enj-minicart-ajax .ajaxcart__qty-adjust',
      function (event) {
        event.preventDefault();

        var $button = $(this);

        var line = parseInt(
          $button.attr('data-line'),
          10
        );

        var $input = $button.siblings(
          '.ajaxcart__qty-num'
        );

        var current = parseInt(
          $input.val(),
          10
        );

        if (isNaN(current)) current = 1;

        var next = Math.max(
          0,
          current + (
            $button.hasClass('ajaxcart__qty--plus')
              ? 1
              : -1
          )
        );

        updateQuantity(line, next);
      }
    );

    $body.on(
      'click.makeloveAjax',
      '.enj-minicart-ajax .remove-product',
      function (event) {
        event.preventDefault();

        updateQuantity(
          parseInt(
            $(this).attr('data-line'),
            10
          ),
          0
        );
      }
    );

    $body.on(
      'change.makeloveAjax',
      '.enj-minicart-ajax textarea[name="note"]',
      function () {
        ShopifyAPI.updateCartNote(
          $(this).val()
        );
      }
    );

    $body.on(
      'submit.makeloveAjax',
      '.enj-minicart-ajax form.ajaxcart',
      function (event) {
        if (busy) event.preventDefault();
      }
    );
  }

  function bindProductQuantities() {
    $('input[type="number"]')
      .not('.ajaxcart__qty-num')
      .each(function () {

        var $input = $(this);

        if (
          $input.closest('.enj-minicart-ajax').length ||
          $input.data('mlQtyReady')
        ) {
          return;
        }

        var qtySource = $('#JsQty').html();

        if (!qtySource || !window.Handlebars) {
          return;
        }

        $input.data('mlQtyReady', true);

        var tpl = window.Handlebars.compile(
          qtySource
        );

        var currentQty =
          parseInt($input.val(), 10) || 1;

        var wrapper = $(tpl({
          id: $input.attr('data-id') || '',
          itemQty: currentQty,
          itemAdd: currentQty + 1,
          itemMinus: Math.max(
            1,
            currentQty - 1
          ),
          inputName:
            $input.attr('name') || 'quantity',
          inputId:
            $input.attr('id') || ''
        }));

        $input.replaceWith(wrapper);
      });

    $body.on(
      'click.makeloveAjax',
      '.js-qty__adjust',
      function (event) {
        event.preventDefault();

        var $button = $(this);

        var $input = $button.siblings(
          '.js-qty__num'
        );

        var qty =
          parseInt($input.val(), 10) || 1;

        qty = Math.max(
          1,
          qty + (
            $button.hasClass(
              'js-qty__adjust--plus'
            ) ? 1 : -1
          )
        );

        $input.val(qty).trigger('change');

        if (
          typeof window.updatePricingQty === 'function'
        ) {
          window.updatePricingQty(qty);
        }
      }
    );
  }

  var ajaxCart = window.ajaxCart || {};

  ajaxCart.init = function (options) {
    settings = $.extend({
      formSelector:
        'form[action^="/cart/add"]',
      cartContainer:
        '#CartContainer',
      addToCartSelector:
        '.enj-add-to-cart-btn',
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: '$',
      disableAjaxCart: false,
      enableQtySelectors: true
    }, options || {});

    $cartContainer = $(settings.cartContainer);

    if (initialized) return;
    initialized = true;

    if (!settings.disableAjaxCart) {
      $body.on(
        'submit.makeloveAjax',
        settings.formSelector,
        submitAddToCart
      );
    }

    bindCartControls();

    if (settings.enableQtySelectors) {
      bindProductQuantities();
    }
  };

  ajaxCart.load = function () {
    return refresh(false);
  };

  window.ajaxCart = ajaxCart;

})(window, window.jQuery);
